import { axiosGetHandler, axiosPostHandler } from './config';

// 活动模版化接口
export function getData(args) {
  let url = '/game/h5_activity/v2/data';
  return axiosGetHandler(url, args);
}

// 抽奖机模块
// 获取抽奖记录
export function getDrawLog(args) {
  let url = '/game/task_open_activity/draw_log';
  return axiosGetHandler(url, args);
}

// 抽奖
export function openBox(args) {
  let url = '/game/h5_activity/open_box';
  return axiosGetHandler(url, args);
}

// 关注/取消关注
export function followUser(url, args, formdata) {
  return axiosPostHandler(url, args, formdata);
}

// 图片点击
export function clickImage(url, args) {
  return axiosGetHandler(url, args);
}

// 积分兑换
export function exchange(args) {
  let url = '/game/h5_activity/redeem/exchange';
  return axiosGetHandler(url, args);
}

// 兑换记录
export function getRecordList(args) {
  let url = '/game/h5_activity/redeem/log';
  return axiosGetHandler(url, args);
}

// 任务点击
//
export function clickTask(args) {
  let url = '/game/task_open_activity/click_task';
  return axiosGetHandler(url, args);
}

// 签到模块
// 订阅
export function subscribeGame(args) {
  let url = '/activity/h5_download_subscribe_activity/subscribe';
  return axiosGetHandler(url, args);
}
// 订阅 or 取消订阅
export function subscribe(args) {
  let url = '/game/h5_activity/push_switch';
  return axiosGetHandler(url, args);
}

// 签到
export function sign(args) {
  let url = '/game/h5_activity/v2/sign_in';
  return axiosGetHandler(url, args);
}

// 投票预测
// 提交预测
export function vote(args) {
  let url = '/game/h5_activity/push_switch';
  return axiosGetHandler(url, args);
}

// 解谜
// 提交解谜
export function submitPuzzle(args) {
  let url = '/game/h5_activity/puzzle_act/answer';
  return axiosGetHandler(url, args);
}

// 通行证
// 领取全部
export function receiveAll(args) {
  let url = '/game/h5_activity/pass_act/submit';
  return axiosGetHandler(url, args);
}

// 上报模块点击次数（图片 任务“前往”按钮  & 页面停留时长
export function reportData(args) {
  let url = '/account/data_report/';
  return axiosGetHandler(url, args);
}

// 新人模块领取
export function recruit(args) {
  let url = '/game/h5_activity/recruit/get_award';
  return axiosGetHandler(url, args);
}

// 领取模块
export function getReceiveAward(args) {
  let url = '/game/h5_activity/receive/get_award';
  return axiosGetHandler(url, args);
}

// 瓜分领取模块
export function getDivideAward(args) {
  let url = '/game/h5_activity/divide/receive';
  return axiosGetHandler(url, args);
}

// 集卡模块抽卡
export function openCard(args) {
  let url = '/game/h5_activity/divide/open_card';
  return axiosGetHandler(url, args);
}

// 集卡模块v2/v3 抽卡
export function openSelectCard(args) {
  let url = '/game/h5_activity/repeatable_card_collect/open_card_box';
  return axiosGetHandler(url, args);
}

// 集卡模块v2/v3 合成
export function combineCard(args) {
  let url = '/game/h5_activity/repeatable_card_collect/combine_card';
  return axiosGetHandler(url, args);
}

//集卡模块 2024 春节
export function combineCard2024(args) {
  let url = '/game/h5_activity/repeatable_card_collect/spring_fes/combine';
  return axiosGetHandler(url, args);
}

// 集卡模块v3 搜索用户id
export function searchUser(args) {
  let url = '/bbs/app/api/general/search/v1';
  return axiosGetHandler(url, args);
}
// 集卡模块v3 获取关注用户
export function getFollowingUsers(args) {
  let url = '/bbs/app/profile/following/list';
  return axiosGetHandler(url, args);
}
//集卡模块v3 赠送卡片
export function sendUserCard(args) {
  let url = '/game/h5_activity/repeatable_card_collect/send_card';
  return axiosPostHandler(url, args);
}

// 大促厂商模块 点击查看更多
export function moreGame(args) {
  let url = '/game/game_compilation_detail/';
  return axiosGetHandler(url, args);
}

// 投票模块提交投票
export function submitVote(args, formdata) {
  let url = '/game/h5_activity/vote_act/general_vote';
  return axiosPostHandler(url, args, formdata);
}
//

// 盒弹相关
export function getLotteryResult(args) {
  let url = '/game/h5_activity/mall_box/open_mall_box';
  return axiosGetHandler(url, args);
}
export function getRecordsData(args) {
  let url = '/game/h5_activity/mall_box/get_logs';
  return axiosGetHandler(url, args);
}
export function hedanSubscribe(args) {
  let url = '/mall/openbox/subscribe/';
  return axiosGetHandler(url, args);
}

// 层级解锁模块领取奖品
export function getStepAward(args) {
  let url = '/game/h5_activity/redeem/collect';
  return axiosGetHandler(url, args);
}

// 层级解锁领取福袋奖励
export function getStepAwardFudai(args) {
  let url = '/game/h5_activity/mall_box/collect_mall_box';
  return axiosGetHandler(url, args);
}

// 层级解锁中奖记录
export function getStepAwardRecord(args) {
  let url = '/game/h5_activity/step_unlock/get_logs';
  return axiosGetHandler(url, args);
}

// 轮询任务完成状态
export function pollTask(args) {
  let url = '/game/h5_activity/common/task_list';
  return axiosGetHandler(url, args);
}

// 获得pubg召回邀请链接
export function getPubgRecallKeyCode(args) {
  let url = '/game/h5_activity/pubg/guild_act/invite_code';
  return axiosGetHandler(url, args);
}

// 接受pubg召回邀请
export function acceptPubgRecall(args) {
  let url = '/game/h5_activity/pubg/guild_act/accept_invite';
  return axiosGetHandler(url, args);
}

// 获取PUBG召回奖品
export function getPubgRecallAward(args) {
  let url = '/game/h5_activity/pubg/guild_act/award';
  return axiosGetHandler(url, args);
}

// 限时领取模块
export function getTimelyCollectionAward(args) {
  let url = '/game/h5_activity/collect_timely_award';
  return axiosGetHandler(url, args);
}

// 2024春节活动
async function _fetch(url) {
  return await fetch(url).then((o) => o.json());
}
export function getJSON(animes) {
  return Promise.all(
    animes.map(async (anime) => {
      return await _fetch(
        `https://static.max-c.com/heybox/spring_festival/${anime}/${anime}.json`,
      );
    }),
  );
}

//秒杀迁移
export function getSecKillSales(args) {
  let url = '/mall/weekly_sales/data';
  return axiosGetHandler(url, args);
}

export function subscribeWeeklySale(args) {
  let url = '/mall/weekly_sales/subcribe';
  return axiosGetHandler(url, args);
}

export function getVoteGroupData(args) {
  let url = '/game/h5_activity/vote_act/get_vote_detail';
  return axiosGetHandler(url, args);
}

export function reportVoteData(args, formdata) {
  let url = '/game/h5_activity/vote_act/heybox_vote';
  return axiosPostHandler(url, args, formdata);
}

// 愿望单里程碑
export function getUserWishlistMilestoneState(args) {
  let url = '/game/get_wishlist_milestones_main/';
  return axiosGetHandler(url, args);
}

export function JoinWishlistMilestoneAct(args, formData) {
  let url = '/game/enter_act/';
  return axiosPostHandler(url, args, formData);
}


export function getPkeyWithToken(args) {
  let url = '/account/web_login_with_token/';
  return axiosGetHandler(url, args);
}
